import React, { useContext } from "react";
import SocketIOContext from "./../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { Button, Grid, Typography, IconButton, TextField } from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import BackspaceIcon from "@mui/icons-material/Backspace";
import CircleButton from "./../Buttons/CircleButton";
import PhoneDisplay from "./PhoneDisplay";

import { useTheme } from "@mui/material/styles";

// props has activeStep
export default function KeypadWidget_B({
  filloutStyle = {},
  buttonRowStyle,
  errorMessageStyle,
  iconStyle,
  circleButtonOverride,
  errorMessage,
  numberbuttonpress,
  clearbuttonpress,
  keypadDone,
  loading
}) {
  const { getKioskTheme } = useContext(SocketIOContext);
  const kiosktheme = getKioskTheme();
  const theme = useTheme();

  // const telephonebuttonpress = event => {
  //   //console.log("telephonebuttonpress", event);
  //   const maxDigits = kiosktheme.phoneFormat?.split("_").length - 1 || 0;

  //   let newNumber = props.phonenumber + event.target.innerText;

  //   props.setPhonenumber(newNumber.substring(0, maxDigits));
  // };

  // const backspacepress = event => {
  //   let newNumber = props.phonenumber;

  //   if (newNumber.length > 0) {
  //     newNumber = newNumber.substring(0, newNumber.length - 1);
  //   }

  //   props.setPhonenumber(newNumber);
  // };

  // const clearbuttonpress = event => {
  //   //console.log("clearbuttonpress", event);
  //   props.setPhonenumber("");
  // };

  // if (props.showconfirmdialog) {
  //   return <></>;
  // }

  return (
    <div
      // style={{
      //   display: "flex",
      //   flexDirection: "column-reverse",
      //   alignItems: "center",
      //   justifyContent: "space-between",
      //   height: "100%",
      //   backgroundColor: "yellow"
      // }}
      id="fillout_keyanderrmessage"
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignContent: "space-between",
        flexWrap: "wrap",
        justifyContent: "center",
        ...filloutStyle
      }}
    >
      <div
        id="keypad"
        style={{ display: "flex", flexDirection: "column", width: "100%" }}
      >
        <div key={"telephoneButRow1"} style={buttonRowStyle}>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={numberbuttonpress}
          >
            1
          </CircleButton>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={numberbuttonpress}
          >
            2
          </CircleButton>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={numberbuttonpress}
          >
            3
          </CircleButton>
        </div>
        <div key={"telephoneButRow2"} style={buttonRowStyle}>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={numberbuttonpress}
          >
            4
          </CircleButton>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={numberbuttonpress}
          >
            5
          </CircleButton>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={numberbuttonpress}
          >
            6
          </CircleButton>
        </div>
        <div key={"telephoneButRow3"} style={buttonRowStyle}>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={numberbuttonpress}
          >
            7
          </CircleButton>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={numberbuttonpress}
          >
            8
          </CircleButton>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={numberbuttonpress}
          >
            9
          </CircleButton>
        </div>
        <div key={"telephoneButRow4"} style={buttonRowStyle}>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={clearbuttonpress}
            color="error"
          >
            <CloseIcon sx={iconStyle} />
          </CircleButton>
          <CircleButton
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            onClick={numberbuttonpress}
          >
            0
          </CircleButton>
          <CircleButton
            disabled={loading}
            onClick={keypadDone}
            PercentSize="10%"
            circleButtonOverride={circleButtonOverride}
            color="success"
          >
            <CheckIcon sx={iconStyle} />
          </CircleButton>
        </div>
      </div>
      <div id="phoneerror">
        <Typography variant="body2" style={errorMessageStyle}>
          {errorMessage}
        </Typography>
      </div>
    </div>
  );
}
